module.exports = __webpack_public_path__ + "media/38.0386c92e.mp3";